// extracted by mini-css-extract-plugin
export default {"tabs":"tabs--XFMFK","metrics":"metrics--JCHmX","destination":"destination--vhQHU","section":"section--dJEK6"};